import { makeStyles } from "@material-ui/core";

export const useEntryViewerStyles = makeStyles((theme) => ({
	root: {
		"& .input-group-text": {
			display: "none",
		},
		"& .MuiDialogContent-dividers": {
			padding: 0,
		},
		"& .MuiOutlinedInput-root.Mui-disabled": {
			"& fieldset": {
				borderColor: "rgba(0, 0, 0, 0.23)",
			},
		},
		"& .MuiSelect-iconOutlined": {
			display: "none",
		},
	},
	datePicker: {
		width: "100%",
		"& .MuiInputBase-root": {
			height: "40px",
			paddingTop: 5,
		},
		"& .MuiOutlinedInput-root": {
			height: "40px",
		},
	},
	paper: {
		width: "100%",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		padding: "20px 20px 10px",
		overflowX: "hidden",
	},
	content: {
		flexGrow: 1,
		overflowY: "auto",
		overflowX: "hidden",
	},
	modalWarning: {
		color: "white",
		backgroundColor: "#dc3545",
		textAlign: "center",
	},
	inputEditable: {
		"& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			border: "2px solid #3F51B5",
		},
		minHeight: "100px",
	},
	disabledInput: {
		"& .MuiInputBase-root.Mui-disabled": {
			color: "rgba(0, 0, 0, 0.6)",
		},
		"& .MuiInputLabel-root.Mui-disabled": {
			color: "rgba(0, 0, 0, 0.6)",
		},
	},
	titleInput: {
		fontSize: "1.5em",
		fontWeight: "bold",
		"& .MuiInputBase-input": {
			padding: "0.5rem",
		},
	},
}));
